﻿import { Button, Flex } from '@chakra-ui/react'
import { useNavigate } from 'react-router'

export const CreateStockPs = ({
  insuranceParamsId: insuranceParamsId,
  isDisabled,
}: {
  insuranceParamsId: string
  isDisabled?: boolean
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    const params = new URLSearchParams({ origParamsId: insuranceParamsId.toString() })
    navigate(`/leasing/stock?${params.toString()}`)
  }

  return (
    <Flex flexDir="column" gap={4} mx={4} w="full">
      <Button
        variant="outline"
        colorScheme="blue"
        onClick={handleClick}
        isDisabled={isDisabled}
        title={isDisabled ? 'Na toto VIN již existuje aktivní skladové pojištění.' : undefined}
      >
        Vytvořit skladové pojištění
      </Button>
    </Flex>
  )
}
